import { render } from "./EduDetail.vue?vue&type=template&id=76477682"
import script from "./EduDetail.vue?vue&type=script&lang=js"
export * from "./EduDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__